import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AnalyticsApi } from 'src/services/analyticsApi'
import { MetaInsightsResponse } from 'src/services/__generated__/api'

interface UseGetInboxMetaInsightsParams {
  fromDate?: string
  pageId: string
  toDate?: string
}

export const useGetInboxMetaInsightsQuery = (
  params: UseGetInboxMetaInsightsParams
) => {
  return useQuery<MetaInsightsResponse | null>({
    enabled: !!params.pageId,
    queryFn: async () => {
      const { data } =
        await AnalyticsApi.v1Private.inboxAnalysisMetaInsightsList(
          {
            fromDate: params.fromDate,
            pageId: params.pageId,
            toDate: params.toDate,
          },
          { format: 'json' }
        )
      return data as MetaInsightsResponse
    },
    queryKey: [
      QueryKey.GET_INBOX_META_INSIGHTS,
      params.pageId,
      params.fromDate,
      params.toDate,
    ],
  })
}
